import { createContext } from "react";
import OrderHistoryTableContextType from "../interfaces/context/OrderHistoryTableContext";

export const OrderHistoryTableContext = createContext<
  OrderHistoryTableContextType | undefined
>(undefined);
